function joinPath(basePath, segment) {
    if (!segment) {
        return basePath
    }

    return `${basePath}/${segment}`.replace(/\/{2,}/g, '/')
}

// Menu items name a route id and nothing else, so the sidebar needs to find a route
// by id and know the path it sits at — which only the chain of ancestors gives.
export function buildRouteIndex(routes, basePath = '') {
    const index = new Map()

    routes.forEach((route) => {
        const path = joinPath(basePath, route.path)

        if (route.id) {
            index.set(route.id, { id: route.id, path, handle: route.handle })
        }

        if (route.children) {
            buildRouteIndex(route.children, path)
                .forEach((entry, id) => index.set(id, entry))
        }
    })

    return index
}
